const path = [
  {
    path: '/setup/object-manager/:prop_type',
    component: () => import('@/views/setup/object-manager/index.vue'),
    children: [
      {
        path: 'details',
        name: 'object-manager-details',
        component: () => import('@/views/setup/object-manager/details/DetailView.vue'),
        meta: {
          layout: 'horizontal',
          app: 'set-up-object',
          appId: 4,
        },
      },
      {
        path: 'field',
        name: 'object-manager-field',
        component: () => import('@/views/setup/object-manager/fields/ListView.vue'),
        meta: {
          layout: 'horizontal',
          app: 'set-up-object',
          appId: 4,
        },
      },
      {
        path: 'field/detail/:id',
        name: 'object-manager-field-detail',
        component: () => import('@/views/setup/object-manager/fields/FieldView.vue'),
        meta: {
          layout: 'horizontal',
          app: 'set-up-object',
          appId: 4,
        },
      },
      {
        path: 'field-relationships',
        name: 'object-manager-field-relationship',
        component: () => import('@/views/setup/object-manager/field-relationship/ListView.vue'),
        meta: {
          layout: 'horizontal',
          app: 'set-up-object',
          appId: 4,
        },
      },
      {
        path: 'field-relationships/:type/:uuid?',
        name: 'setup-field-relationship-form',
        component: () => import('@/views/setup/object-manager/field-relationship/CreateForm.vue'),
        meta: {
          layout: 'horizontal',
          app: 'set-up-object',
          appId: 4,
        },
      },
      {
        path: 'page-layout',
        name: 'object-manager-layout',
        component: () => import('@/views/setup/object-manager/page-layout/ListView.vue'),
        meta: {
          layout: 'horizontal',
          app: 'set-up-object',
          appId: 4,
        },
      },
      {
        path: 'page-layout/:id',
        name: 'object-manager-view-layout',
        component: () => import('@/views/setup/object-manager/page-layout/Layout.vue'),
        meta: {
          layout: 'horizontal',
          app: 'set-up-object',
          appId: 4,
        },
      },
      {
        path: 'validation-rules',
        name: 'object-manager-validations',
        component: () => import('@/views/setup/object-manager/validation-rules/ListView.vue'),
        meta: {
          layout: 'horizontal',
          app: 'set-up-object',
          appId: 4,
        },
      },
      {
        path: 'validation-rules/detail',
        name: 'object-manager-validation-rule-detail',
        component: () => import('@/views/setup/object-manager/validation-rules/DetailView.vue'),
        meta: {
          layout: 'horizontal',
          app: 'set-up-object',
          appId: 4,
        },
      },
      {
        path: 'validation-rules/detail/:id',
        name: 'object-manager-validation-rule-edit',
        component: () => import('@/views/setup/object-manager/validation-rules/ValidationView.vue'),
        meta: {
          layout: 'horizontal',
          app: 'set-up-object',
          appId: 4,
        },
      },
      {
        path: 'validation-rules/add',
        name: 'object-manager-validation-rule-add',
        component: () => import('@/views/setup/object-manager/validation-rules/ValidationView.vue'),
        meta: {
          layout: 'horizontal',
          app: 'set-up-object',
          appId: 4,
        },
      },
    ],
  },
]

export default path
